import { Course } from '../course/course.model';
import { Workshop } from '../workshop/workshop.model';
import { isCourse } from '../course/course.util';
import { Registration } from './registration.model';
import { Child } from '../child/child.model';

export function getRegistrationKey(
  resource: Course | Workshop,
): 'course' | 'workshop' {
  return isCourse(resource) ? 'course' : 'workshop';
}

export function patchRegistration(registration: Registration) {
  registration.attendant = new Child(registration.attendant);
  if (registration.workshop)
    registration.workshop = new Workshop(registration.workshop);
  if (registration.course)
    registration.course = new Course(registration.course);
  return registration;
}
